/**
 * Responsive Manager Module
 * Handles viewport changes and mobile/desktop mode switching
 */

// Prevent redeclaration if script is loaded multiple times
if (typeof ResponsiveManager === 'undefined') {
  class ResponsiveManager {
  constructor() {
    this.breakpoints = {
      mobile: 767,
      tablet: 1199,
      desktop: 1200
    };
    this.currentMode = 'desktop';
    this.listeners = [];
  }

  /**
   * Get current viewport mode
   */
  getCurrentMode() {
    const width = window.innerWidth;
    if (width <= this.breakpoints.mobile) {
      return 'mobile';
    } else if (width <= this.breakpoints.tablet) {
      return 'tablet';
    }
    return 'desktop';
  }

  /**
   * Check if currently mobile
   */
  isMobile() {
    return this.getCurrentMode() === 'mobile';
  }

  /**
   * Check if currently desktop
   */
  isDesktop() {
    return this.getCurrentMode() === 'desktop';
  }

  /**
   * Single predicate for mobile-native content mode.
   * Prefer this over inline matchMedia checks.
   */
  isMobileNativeMode() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  /**
   * Initialize responsive manager
   */
  init() {
    this.currentMode = this.getCurrentMode();
    this.handleResize();
    window.addEventListener('resize', () => this.handleResize());
  }

  /**
   * Handle viewport resize
   */
  handleResize() {
    const newMode = this.getCurrentMode();
    const modeChanged = newMode !== this.currentMode;

    if (modeChanged) {
      const oldMode = this.currentMode;
      this.currentMode = newMode;
      this.notifyListeners(oldMode, newMode);
    }

    // NOTE: window constraint on resize is owned by WindowManager.initResponsiveListeners.
    // Do not duplicate that work here.
  }

  /**
   * Add resize listener
   */
  onModeChange(callback) {
    this.listeners.push(callback);
  }

  /**
   * Notify all listeners of mode change
   */
  notifyListeners(oldMode, newMode) {
      this.listeners.forEach(callback => callback(oldMode, newMode));
  }
  }
  
  // Export to global scope
  window.ResponsiveManager = ResponsiveManager;
}

window.isMobileNativeMode = function () {
    return window.matchMedia('(max-width: 767px)').matches;
};

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ResponsiveManager;
}

